import { Component, ElementRef, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { NavMenuService } from 'src/app/core/nav-menu/service/nav-menu.service';
import { IIDN } from 'src/app/shared/models/IIDN';
import { ResourcesService } from 'src/app/shared/services/resources.service';
import { Sort } from 'src/app/shared/util/sort';
import { IdnService } from './shared/idn.service';

@Component({
  selector: 'app-idns',
  templateUrl: './idns.component.html',
  styleUrls: ['./idns.component.css']
})
export class IdnsComponent implements OnInit, OnDestroy {
  idns: IIDN[];
  rowIdns: IIDN[];
  pageSizeOptions = [];
  pageSize: number = 25;
  pageSizeDisplay = 25;
  pageIndex = 1;
  numberOfPages = 0;
  isLoading = true;
  totalNumber: number;
  cols: any;
  resourceKeyValue: any = null;
  maxSize = 5;
  idns2display: IIDN[];
  directionColumnName: string = 'asc';
  labelNoIDNSFound: string = ""
  sortableState = '1';
  selectedItem = 2;
  isDefaultSort = true;
  navMenuService$: any

  rowsPerPageForm = this.fb.group({
    rowsPerPage: ['0', [Validators.required]],
  })

  searchIdnsForm = this.fb.group({
    term: [''],
  });

  @ViewChild("idnTable", { read: ElementRef }) idnTable: ElementRef;

  constructor(private idnService: IdnService,
    private fb: UntypedFormBuilder,
    private resourcesService: ResourcesService,
    private renderer: Renderer2,
    private navMenuService: NavMenuService
  ) { }

  ngOnInit(): void {

    this.resourcesService.bsObject.subscribe(result => {
      result && (this.resourceKeyValue = result);
      this.labelNoIDNSFound = this.resourceKeyValue.idnNoIDNSFound;
      this.pageSizeOptions = [10, 25, 50, 100, { showAll: this.resourceKeyValue.showAll }];
    });

    this.navMenuService$ = this.navMenuService.navMenuChangeSubscription()
      .subscribe((isChanged: any) => {
        if (this.searchIdnsForm && isChanged) {
          this.searchIdnsForm.controls['term'].patchValue('');
          this.navMenuService.onNavMenuChange(false);
          this.search(undefined);
        }
      })

    this.isLoading = true;

    //Setting initialization lengend for "No IDNs Found"
    //It will be displayed in the search and when there are no IDNs in the table
    this.labelNoIDNSFound = this.resourceKeyValue.idnNoIDNSFound;
    this.getAllIDNs();
  }

  getAllIDNs(): void {
    this.idnService.getAllIDNs().subscribe(idnsData => {
      this.rowIdns = idnsData;
      this.idns = idnsData;      
      this.totalNumber = idnsData.length;
      this.numberOfPages = Math.ceil(this.totalNumber / this.pageSize);
      //first ordering the records by name asc
      this.columnSort('name', this.directionColumnName);
      this.isLoading = false;
    },
      (error) => {
        if (error.code == 404) {
          this.idns = [];
          this.rowIdns = [];
          this.isLoading = false;
          this.searchIdnsForm.controls['term'].disable();
          return;
        }
        console.error(error);
      });
  }

  refreshIdns() {
    this.isDefaultSort = true;
    this.idns2display = this.idns
      .map((idn, i) => ({ id: i + 1, ...idn }))
      .slice((this.pageIndex - 1) * this.pageSize, (this.pageIndex - 1) * this.pageSize + this.pageSize);
    this.numberOfPages = Math.ceil(this.totalNumber / this.pageSize);

    if (this.idnTable) {
      let elements: Element[] = this.idnTable.nativeElement.getElementsByClassName('sorted-desc') || this.idnTable.nativeElement.getElementsByClassName('sorted-asc');
      if (elements && elements.length) {
        Array.from(elements).forEach((element: any) => {
          this.renderer.removeClass(element, 'sorted-desc');
          this.renderer.removeClass(element, 'sorted-asc');

          if (element.getAttribute('data-order') && element.getAttribute('data-order') == 'asc') {
            element.setAttribute('data-order', 'desc');
          }
        });
      }

      let sortElement = this.idnTable.nativeElement.getElementsByClassName('initialSort');
      if (sortElement && sortElement.length) {
        this.renderer.addClass(sortElement[0], 'sorted-asc');
      }
    }

    this.sortableState = '1';
    this.columnSort('name', this.directionColumnName);
  }

  columnSort(property: string, direction: string) {
    const dataSort = new Sort();
    this.idns.sort(dataSort.startSort(property, direction));
  }

  matches(idn: IIDN, term: string) {
    return idn.name.toLowerCase().includes(term.toLocaleLowerCase());
  }

  search(event: Event) {
    this.isDefaultSort = true;
    this.idns = this.rowIdns;
    const filterValue = event ? (event.target as HTMLInputElement).value : '';
    this.idns = this.idns.filter(x => this.matches(x, filterValue));
    this.totalNumber = this.idns.length;
    this.refreshIdns();
    this.columnSort('name', this.directionColumnName);
  }

  changeColumnDirection(direction: string) {
    if (direction === 'asc') {
      return direction = 'desc';
    } else {
      return direction = 'asc';
    }
  }
  isNumber(val): boolean { return typeof val === 'number'; }

  ngOnDestroy() {
    if (this.navMenuService$) {
      this.navMenuService$.unsubscribe();
    }
  }
}